module.exports = __webpack_public_path__ + "img/74.08bdff86.jpg";